export const NO_END_DATE = '2099-12-31';
export const MIN_DATE = '1970-01-01';
export const MS_PER_DAY = 86400000;
export const PLANNING_DAYS_PER_MONTH = 30;
